import { values } from 'ramda';

import { ROUTER_PATHS } from '@constants/router';

import { NOTIFICATION_VARIANTS } from '../types';

const VALID_VARIANTS = values(NOTIFICATION_VARIANTS);

export const getVariant = (variant: string | null | undefined): NOTIFICATION_VARIANTS => {
  if (!variant || !VALID_VARIANTS.includes(variant as NOTIFICATION_VARIANTS)) {
    return NOTIFICATION_VARIANTS.INFORMATIVE;
  }

  return variant as NOTIFICATION_VARIANTS;
};

export const canRenderInThisPath = (pathname: string, homeOnly: boolean): boolean => {
  return homeOnly ? pathname !== ROUTER_PATHS.HOME : true;
};
